import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ViolationSource } from '../models';
import { BaseApiService } from './baseApiService';
import { StorageKey } from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class ViolationSourceService extends BaseApiService<ViolationSource> {
  get cacheKey(): StorageKey {
    return StorageKey.violationSourceServiceCache;
  }

  getUrl(operation: string, params, id: string = null): string {
    let url = `${environment.apiUrl}/violationSources`;
    if (id != null) {
      url = url + '/' + encodeURIComponent(id);
    }
    return url;
  }

  protected unparse(obj) {
    return ViolationSource.unparse(obj);
  }

  protected parse(obj) {
    return ViolationSource.parse(obj);
  }
}
